/** 更正紀錄／移除後完成確認的 query key；掛在報修單 detail 底下，invalidate detail 時一併失效。 */
export function repairRequestCorrectionsQueryKey(id) {
  return ['erp', 'repairRequest', 'detail', id, 'corrections'];
}

export function repairRequestCompletionAfterRemovalQueryKey(id) {
  return ['erp', 'repairRequest', 'detail', id, 'completionAfterRemoval'];
}
